package ru.villawonka.app.common.extensions

import androidx.compose.ui.graphics.Color

fun Color.toHexString(): String {
    // Получаем компоненты цвета (значения от 0f до 1f)
    val red = (red * 255).toInt()
    val green = (green * 255).toInt()
    val blue = (blue * 255).toInt()

    // Преобразуем каждую компоненту в HEX и форматируем
    return "#${red.toHex()}${green.toHex()}${blue.toHex()}"
}

// Функция для преобразования числа в двузначный HEX
private fun Int.toHex(): String {
    val hex = this.toString(16) // Преобразуем в HEX
    return if (hex.length == 1) "0$hex" else hex // Добавляем ведущий ноль, если нужно
}